// Third-party
import React from 'react';
import { Switch, Route, withRouter, RouteComponentProps } from 'react-router';

// Components
import EnterpriseAdminDetails from '@/types/enterprise-admin-details';
import EnterpriseAdminGroup from '@/types/enterprise-admin-group';
import EnterpriseGroup from '@/types/enterprise-group';
import EnterpriseGroupDetails from './EnterpriseGroupDetails';
import EnterpriseGroups from './EnterpriseGroups';
import NavigationItem from '@/types/navigation-item';
import User from '@/types/user';

// TODO: @deprecate when we deprecate Legacy
import LegacyAdminGroups from './LegacyAdminGroups';
import useThemeVersion from '@/hooks/useThemeVersion';

type ParentProps = {
  adminDetails: EnterpriseAdminDetails;
  pills?: NavigationItem[];
  groups: Array<EnterpriseAdminGroup>;
  user: User;
  onAddGroup: (name: string) => Promise<EnterpriseGroup>;
};

type Props = RouteComponentProps & ParentProps;

const AdminGroups: React.FC<Props> = (props: Props) => {
  const { pills, user } = props;

  const onRowClick = (id: string) => {
    const { groups, history } = props;

    const group = groups.find(grp => grp._id === id);
    const groupId = group != null ? group._id : undefined;

    history.push(`/admin/groups/${groupId}`);
  };

  return (
    <div className="admin-enterprise group-tab">
      <Switch>
        <Route path="">
          <Route exact path="/admin/groups">
            <EnterpriseGroups pills={pills} onRowClick={onRowClick} />
          </Route>
          <Route path="/admin/groups/:id">
            <EnterpriseGroupDetails pills={pills} user={user} />
          </Route>
        </Route>
      </Switch>
    </div>
  );
};

const AdminGroupsComponent = (props: Props) => {
  const { isLightVersion } = useThemeVersion();
  if (isLightVersion) {
    return <AdminGroups {...props} />;
  }
  return <LegacyAdminGroups {...props} />;
};

export default withRouter(AdminGroupsComponent);
